import { useBreakpoints } from '@vueuse/core'
import { screens } from '/theme'

export default () => useBreakpoints(screens)